import { render, staticRenderFns } from "./AppMenuSubitems.vue?vue&type=template&id=528f1bde&scoped=true"
import script from "./AppMenuSubitems.vue?vue&type=script&lang=js"
export * from "./AppMenuSubitems.vue?vue&type=script&lang=js"
import style0 from "./AppMenuSubitems.vue?vue&type=style&index=0&id=528f1bde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528f1bde",
  null
  
)

/* custom blocks */
import block0 from "./AppMenuSubitems.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports